var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Multiselect", {
    staticClass: "property-alarm-new",
    attrs: {
      "track-by": "value",
      label: "label",
      placeholder: _vm.$t("calendar", "+ Add reminder"),
      options: _vm.options,
      searchable: false
    },
    on: { select: _vm.addReminderFromSelect }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }